var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.134 0 0 3.128 0 6.988a6.982 6.982 0 0 0 3.629 6.124L3.546 16l3.303-2.032c.05.001.1.008.151.008 3.866 0 7-3.129 7-6.988C14 3.128 10.866 0 7 0zm.892 11.06H6.098V5.296h1.794v5.764zm-.91-6.47c-.567 0-.944-.401-.932-.896-.012-.519.365-.908.944-.908s.946.39.958.908c0 .495-.38.896-.97.896z",
    fill: "#D8D8DD",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNew);
export default __webpack_public_path__ + "static/media/info-new.4a400012abe5e48f7e27009c94f3e32b.svg";
export { ForwardRef as ReactComponent };